import { render, staticRenderFns } from "./InboxHome.vue?vue&type=template&id=12767b96&scoped=true&"
import script from "./InboxHome.vue?vue&type=script&lang=js&"
export * from "./InboxHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12767b96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12767b96')) {
      api.createRecord('12767b96', component.options)
    } else {
      api.reload('12767b96', component.options)
    }
    module.hot.accept("./InboxHome.vue?vue&type=template&id=12767b96&scoped=true&", function () {
      api.rerender('12767b96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TeamInbox/InboxHome.vue"
export default component.exports